export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Make_Sure.mp3";